import config from "../config";

const api_url = config.api_url;

const accepted_subdomains = ["arborplace","qa"];

const requestOptions = (type = 'POST') => {
    return {
        method: type,
        headers: {
            "Content-Type": "application/json"
        }
    }
}

const createTextPatient = (data, subdomain) => { 
    data.source = `(${subdomain}): ${data.source}`;
    let body = {
        ...data,
        statuses_id: 1,
        next_contact_date: new Date(),
        entity_id: ''
    }
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/connection`, options)
        .then(response => response.json());
}

export {
    createTextPatient,
    accepted_subdomains
}